/**
 * Payroll Subgraph Route Configuration (METADATA-DRIVEN)
 *
 * Phase 2 Implementation: Uses MetadataRoutes for generic entity rendering
 *
 * Before: 66 hardcoded page components across 7 directories
 * After: 1 MetadataRoutes component + 5 custom renderers (79% code reduction)
 *
 * All payroll entity types now use:
 * - PayrollEmployee (list/detail pages auto-generated)
 * - PayrollCompensation (list/detail pages auto-generated)
 * - PayrollBenefitEnrollment (list/detail pages auto-generated)
 * - PayrollRun (list/detail pages auto-generated)
 * - etc.
 *
 * DRR-065: Metadata Discovery Pattern
 * DRR-052: Type Naming (PayrollXxx prefix)
 * DRR-051: Entity Codes (PAY, COMP, BENE, etc.)
 */

import React from 'react';
import { RouteObject } from 'react-router-dom';
import { MetadataRoutes } from '@/routes/MetadataRoutes';

/**
 * Payroll Subgraph Routes (Metadata-Driven)
 *
 * Generic route handler works for ALL payroll entity types
 * Pattern: /payroll/entities/:subgraph/:entityType[/:id]
 */
export const payrollRoutes: RouteObject[] = [
  {
    path: 'payroll',
    children: [
      {
        path: 'entities/*',
        element: <MetadataRoutes />,
      },
    ],
  },
];

/**
 * Create Payroll Router for mounting
 *
 * Usage in main App.tsx:
 *   import { payrollRoutes } from '@/pages/subgraphs/payroll/routes'
 *   <Route path="/admin/*" element={<YourRouterComponent routes={payrollRoutes} />} />
 */
export function PayrollRouter(): React.ReactElement {
  return <MetadataRoutes />;
}

export default payrollRoutes;
